export default "__VITE_ASSET__Cw_nduq0__"